import * as _ from "underscore";

import {Deserialize, deserialize, deserializeAs} from 'libs/cerialize';

export class ActiveSessionsDto {
    @deserialize
    ApiClient: string;

    @deserialize
    Count: number;
}

export class EnvironmentDto {
    @deserialize
    Url: string;

    @deserialize
    Type: string;

    @deserialize
    DatabaseName: string;

    @deserialize
    Size: string;
    
    @deserialize
    LastLoginDate: string;

    @deserialize
    ActiveSessionCount: number;

    @deserializeAs(ActiveSessionsDto)
    ActiveSessions: ActiveSessionsDto[];

    @deserialize
    Notes: string;

    @deserialize
    Id: number;

    @deserialize
    IsMarkedForDeletion: boolean;
}